var _excluded = ["value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Flex } from "../flex";
import { Position } from "../position";
import animate from "../../helpers/animate";
import debounce from 'lodash/debounce';
import ScrollButton from "./ScrollButton";
import { Tab } from "./tab";
import { _getBaseStyle, _getTabWrapperStyle, _getIndicatorStyle } from "./Tabs.styles";

var Tabs = function Tabs(props) {
  var childrenProp = props.children,
      onChange = props.onChange,
      value = props.value,
      appearance = props.appearance,
      scrollButtons = props.scrollButtons,
      maximized = props.maximized;
  var indicator = appearance === 'default';

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      indicatorLeft = _React$useState2[0],
      setIndicatorLeft = _React$useState2[1];

  var _React$useState3 = React.useState(160),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      indicatorWidth = _React$useState4[0],
      setIndicatorWidth = _React$useState4[1];

  var _React$useState5 = React.useState({
    start: false,
    end: false
  }),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      displayScroll = _React$useState6[0],
      setDisplayScroll = _React$useState6[1];

  var tabsRef = React.useRef(null);
  var tabListRef = React.useRef(null);
  var getTabsMeta = React.useCallback(function () {
    var tabsNode = tabsRef.current;
    var tabsMeta;
    var tabMeta;
    var tabNode;

    if (tabsNode) {
      var rect = tabsNode.getBoundingClientRect();
      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollWidth: tabsNode.scrollWidth,
        left: rect.left,
        right: rect.right
      };
      var _children = tabListRef.current.children;

      if (_children.length > 0) {
        tabNode = _children[value];
        tabMeta = tabNode ? tabNode.getBoundingClientRect() : null;
      }
    }

    return {
      tabsMeta: tabsMeta,
      tabMeta: tabMeta
    };
  }, [value]); // To set the selected tab in view

  React.useEffect(function () {
    var _getTabsMeta = getTabsMeta(),
        tabsMeta = _getTabsMeta.tabsMeta,
        tabMeta = _getTabsMeta.tabMeta;

    if (indicator) {
      var _indicatorLeft = tabMeta.left - tabsMeta.left + tabsMeta.scrollLeft;

      setIndicatorLeft(_indicatorLeft);
      setIndicatorWidth(tabMeta.width);
    }

    if (tabMeta.left < tabsMeta.left) {
      // left side Tab is out of view
      var nextScrollStart = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);
      scroll(nextScrollStart);
    } else if (tabMeta.right > tabsMeta.right) {
      // right side Tab is out of view
      var _nextScrollStart = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);

      scroll(_nextScrollStart);
    }
  }, [getTabsMeta, indicator]);
  React.useEffect(function () {
    updateScrollButtonState();
  });

  var scroll = function scroll(scrollValue) {
    animate('scrollLeft', tabsRef.current, scrollValue);
  };

  var updateScrollButtonState = React.useCallback(function () {
    if (scrollButtons) {
      var _tabsRef$current = tabsRef.current,
          scrollWidth = _tabsRef$current.scrollWidth,
          clientWidth = _tabsRef$current.clientWidth,
          scrollLeft = _tabsRef$current.scrollLeft;
      var showStartScroll = scrollLeft > 1;
      var showEndScroll = scrollLeft < scrollWidth - clientWidth - 1;

      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
        setDisplayScroll({
          start: showStartScroll,
          end: showEndScroll
        });
      }
    }
  }, [scrollButtons, displayScroll.start, displayScroll.end]);
  var handleTabsScroll = React.useMemo(function () {
    return debounce(function () {
      updateScrollButtonState();
    });
  }, [updateScrollButtonState]);
  var childIndex = 0;
  var children = React.Children.map(childrenProp, function (child) {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return null;
    }

    var _child$props = child.props,
        childPropsValue = _child$props.value,
        restProps = _objectWithoutProperties(_child$props, _excluded);

    var childValue = childPropsValue === undefined ? childIndex : childPropsValue;
    childIndex += 1;
    var isActive = childValue === value;
    var childElement = /*#__PURE__*/React.cloneElement(child, _objectSpread({
      isActive: isActive,
      onChange: onChange,
      appearance: appearance,
      value: childValue
    }, restProps));
    return /*#__PURE__*/React.createElement(Flex, {
      key: childIndex,
      flexGrow: maximized ? 1 : 0,
      sx: _getTabWrapperStyle(props)
    }, childElement);
  });
  var tabsElement = /*#__PURE__*/React.createElement(Position, {
    position: "relative",
    ref: tabsRef,
    sx: _getBaseStyle(props),
    onScroll: handleTabsScroll
  }, /*#__PURE__*/React.createElement(Flex, {
    ref: tabListRef
  }, children), indicator && /*#__PURE__*/React.createElement(Position, {
    as: "span",
    position: "absolute",
    height: "4px",
    width: "".concat(indicatorWidth, "px"),
    bottom: "0",
    sx: _objectSpread({
      transform: "translateX(".concat(indicatorLeft, "px)")
    }, _getIndicatorStyle(props))
  }));

  var handleStartScrollClick = function handleStartScrollClick() {
    moveTabsScroll(-1 * getScrollSize());
  };

  var handleEndScrollClick = function handleEndScrollClick() {
    moveTabsScroll(getScrollSize());
  };

  var moveTabsScroll = function moveTabsScroll(delta) {
    var scrollValue = tabsRef.current.scrollLeft;
    scrollValue += delta;
    scroll(scrollValue);
  };

  var getScrollSize = function getScrollSize() {
    var containerSize = tabsRef.current.clientWidth;
    var totalSize = 0;
    var children = Array.from(tabListRef.current.children);

    for (var i = 0; i < children.length; i += 1) {
      var tab = children[i];

      if (totalSize + tab.clientWidth > containerSize) {
        break;
      }

      totalSize += tab.clientWidth;
    }

    return totalSize;
  };

  if (scrollButtons) {
    return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(ScrollButton, {
      direction: "left",
      onClick: handleStartScrollClick,
      visible: displayScroll.start
    }), tabsElement, /*#__PURE__*/React.createElement(ScrollButton, {
      direction: "right",
      onClick: handleEndScrollClick,
      visible: displayScroll.end
    }));
  }

  return tabsElement;
};

Tabs.displayName = 'Tabs';
Tabs.defaultProps = {
  appearance: 'default',
  scrollButtons: false,
  centered: false
};
export default Tabs;
export { Tabs };